var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardButtonModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 3.33333C6.66699 2.59695 7.26395 2 8.00033 2C8.73671 2 9.33366 2.59695 9.33366 3.33333C9.33366 4.06971 8.73671 4.66667 8.00033 4.66667C7.26395 4.66667 6.66699 4.06971 6.66699 3.33333ZM6.66699 8C6.66699 7.26362 7.26395 6.66667 8.00033 6.66667C8.73671 6.66667 9.33366 7.26362 9.33366 8C9.33366 8.73638 8.73671 9.33333 8.00033 9.33333C7.26395 9.33333 6.66699 8.73638 6.66699 8ZM6.66699 12.6667C6.66699 11.9303 7.26395 11.3333 8.00033 11.3333C8.73671 11.3333 9.33366 11.9303 9.33366 12.6667C9.33366 13.403 8.73671 14 8.00033 14C7.26395 14 6.66699 13.403 6.66699 12.6667Z",
    fill: "#087678"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardButtonModal);
export default __webpack_public_path__ + "static/media/dashboard_button_modal.a7489896.svg";
export { ForwardRef as ReactComponent };